<template>
  <div class="region-chart chart-w d-block w-100">
    <div class="region-chart__wrapper">
      <Apexchart
        :options="chartOptions"
        :series="categories?.length ? series : []"
        :height="stylesChart.heightBarChart"
      />
    </div>

    <div class="region-chart__menu">
      <div class="region-chart__menu-left">
        <div class="region-chart__title">
          {{ t("regions_stat_bar.title") }}
        </div>
      </div>
      <div
        id="chart-control"
        class="region-chart__menu-right"
      >
        <RefreshIcon @click="loadData" />
        <CalendarInput v-model="date" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStatRegionsStore } from "@/store/Analytic/chart/stat-regions";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { stylesChart } from "@/tools/tooltipChart";
import VueApexCharts from "vue3-apexcharts";
import useBarChart from "@/mixins/apexChart/barChart";
import { t } from "@/controllerLK/GlobusLocalization";
import useFilterDate from "@/mixins/apexChart/filterDate";
import CalendarInput from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/blocks/CalendarInput.vue";
import RefreshIcon from "@/components/Icons/RefreshIcon.vue";

export default {
  name: "RegionStatBar",
  components: {CalendarInput, Apexchart: VueApexCharts, RefreshIcon },
  setup() {
    const statStorage = useStatRegionsStore();
    const newsStorage = useNewsFeedStore();

    const { date } = useFilterDate(loadData);

    async function loadData() {
      await statStorage.loadStat(date.value[0], date.value[1]);
    }

    const allCategories = computed(() => {
      const regions = newsStorage.projectCities;
      if (!regions?.length) return [];
      const sortedItems = (statStorage.items || []).sort((a, b) => b.data - a.data);
      const regionNames = (sortedItems || []).map((item) => {
        const regionObj = regions.find((reg) => reg.id === item.name);
        return regionObj?.city ? regionObj.city : "No name";
      });
      return regionNames;
    });

    const categories = computed(() => allCategories.value.filter((item) => item !== "No name"));

    const series = computed(() => {
      const data = (statStorage.items || [])
        .map((item) => item.data)
        .filter((item, index) => (allCategories.value[index] !== "No name"));
      return [{
        name: " ",
        data: data.sort((a, b) => { return b - a; }),
        color: "#AB83FF"
      }];
    });

    const { chartOptions } = useBarChart(
      {
        titleText: t("regions_stat_bar.title"),
      },
      categories,
      series
    );

    return { categories, date, series, chartOptions, loadData, stylesChart, t };
  },
};
</script>

<style lang="scss" scoped>
.region-chart {
  &__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
  }

  &__menu {
    display: flex;
    position: absolute;
    align-items: center;
    top: 24px;
    height: 42px;
    width: 100%;
    left: 0;
    padding: 0 24px;
    justify-content: space-between;

    &-left {
      display: flex;
      gap: 20px;
    }

    &-right {
      display: flex;
      gap: 14px;
    }
  }
}
</style>